import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ISimpleData } from '../../../../../shared/models/simpleData.model';
import { GeneralSettingsService } from '../../../../../services/general-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../../services/toast.service';
import { IDelayCode } from '../../../../../shared/models/delay-code.model';
import { IAirlineDesignator } from '../../../../../shared/models/airline-designator.model';

@Component({
  selector: 'app-add-edit-delay-code-dialog',
  templateUrl: './add-edit-delay-code-dialog.component.html',
  styleUrls: ['./add-edit-delay-code-dialog.component.scss']
})
export class AddEditDelayCodeDialogComponent implements OnInit {

  form?: UntypedFormGroup;
  isBusy = false;
  @Input() delayCode?: IDelayCode;
  @Input() designators?: IAirlineDesignator[];
  constructor(private generalSettingsService: GeneralSettingsService, private activeModal: NgbActiveModal, private toastService: ToastService) { }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      code: new UntypedFormControl(this.delayCode?.code || '', Validators.required),
      description: new UntypedFormControl(this.delayCode?.description || '', Validators.required)
    });
  }

  closeModal(reason?: any) {
    this.activeModal.dismiss(reason);
  }

  onSaveClick() {
    const data: IDelayCode = { ...this.form.value, id: this.delayCode?.id, applicableAirlineDesignatorId: this.designators?.[0]?.id || 1 };
    this.isBusy = true;
    this.generalSettingsService.saveDelayCode(data).subscribe((result) => {
      if(result?.id) {
        this.toastService.showSuccess("Delay code has been saved");
        this.closeModal(true);
      }
      this.isBusy = false;
    });

  }

}
